import Drawer from '../../components/Drawer/Drawer';
import React from 'react';
import Filter, { FilterItem } from './Filter';
import Icon from '../../common/components/Icon';
import Dropdown from '../../components/dropdown/Dropdown';
import { useTranslations } from '../../localization/useTranslations';

interface FilterAndSortBarProps {
  onDropdownChange: (item: {
    label: string;
    sortBy: 'id' | 'price_amount' | 'created_at';
    sortOrder: 'asc' | 'desc';
  }) => void;
  onFilterChange: (selectedFilters: Array<FilterItem>) => void;
  filters?: Array<FilterItem>;
  filterName: string;
  hideFilter?: boolean;
}

const FilterAndSortBar = ({
  onDropdownChange,
  onFilterChange,
  filters,
  filterName,
  hideFilter = false,
}: FilterAndSortBarProps) => {
  const [filterIsOpen, setFilterIsOpen] = React.useState(false);
  const [, setSelectedFilters] = React.useState<Array<FilterItem>>([]);
  const translations = useTranslations();

  const applyButton = {
    label: translations?.ecommerce?.applyButton || 'Apply',
    onClick: (selectedItems: FilterItem[]) => {
      setSelectedFilters(selectedItems);
      setFilterIsOpen(false);
      onFilterChange(selectedItems);
    },
  };

  const resetButton = {
    label: translations?.ecommerce?.resetButton || 'Reset',
    onClick: () => {
      setSelectedFilters([]);
      setFilterIsOpen(false);
      onFilterChange([]);
    },
  };

  const sortByItems: {
    label: string;
    sortBy: 'id' | 'price_amount' | 'created_at';
    sortOrder: 'asc' | 'desc';
  }[] = [
    { label: 'Forbes doporučuje', sortBy: 'id', sortOrder: 'desc' },
    { label: 'Nejnovší', sortBy: 'created_at', sortOrder: 'desc' },
    {
      label: 'Cena od nejvyšší po nejnižší',
      sortBy: 'price_amount',
      sortOrder: 'desc',
    },
    {
      label: 'Cena od nejnižší po nejvyšší',
      sortBy: 'price_amount',
      sortOrder: 'asc',
    },
  ];

  const selectActiveSortingItem = () => {
    const url = new URL(window.location.href);
    const sortBy = url.searchParams.get('sortBy');
    const sortOrder = url.searchParams.get('sortOrder');

    return sortByItems.find((item) => item.sortBy === sortBy && item.sortOrder === sortOrder);
  };

  const handleDropdownChange = (item: {
    label: string;
    sortBy: 'id' | 'price_amount' | 'created_at';
    sortOrder: 'asc' | 'desc';
  }) => {
    onDropdownChange(item);
  };

  return (
    <div className="ecom-filter-and-sort-bar">
      <div className="ecom-filter-and-sort-bar__filter-buttons">
        {hideFilter ? (
          <div />
        ) : (
          <div className="ecom-filter-and-sort-bar__filter-button">
            <Icon name="filter" size="small" />
            <button onClick={() => setFilterIsOpen(true)} className="link-14">
              {translations?.ecommerce?.openFilters || 'Open filters'}
            </button>
          </div>
        )}

        <div className="ecom-filter-and-sort-bar__sort-by-dropdown">
          <Dropdown items={sortByItems} onChange={handleDropdownChange} selectedItem={selectActiveSortingItem()} />
        </div>
      </div>

      {!hideFilter && (
        <Drawer isOpen={filterIsOpen} onClose={() => setFilterIsOpen(false)}>
          <Filter title={filterName} applyButton={applyButton} resetButton={resetButton} items={filters || []} />
        </Drawer>
      )}
    </div>
  );
};

export default FilterAndSortBar;
